"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7798],{

/***/ 37798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tag_items_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/default-props.js

/* harmony default export */ var default_props = ({
    tagBackgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/tag.scss.js

var TAG_IMAGE_SIZE = "44px";
var StyledTagAnchorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "es7hxax0"
})("text-decoration:none;color:unset;cursor:pointer;");
var StyledTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es7hxax1"
})("display:flex;flex-direction:row;justify-content:center;align-items:center;&.has-on-click-behavior{cursor:pointer;}.tag-image-wrapper{display:flex;align-items:center;justify-content:center;border-radius:50%;.tag-picture{.tag-icon{height:100%;}}}.tag-text{margin-left:8px;font-size:1.125rem;line-height:22px;font-weight:300;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/tag.js









var Tag = function(props) {
    var tagIconsrc = props.tagIconsrc, tagText = props.tagText, onClick = props.onClick, tagBackgroundColor = props.tagBackgroundColor, tagImageHeight = props.tagImageHeight, href = props.href, openInNewTab = props.openInNewTab, noImageWidth = props.noImageWidth, tagTextSize = props.tagTextSize;
    var onTagClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: tagText,
            info1: href
        });
        if (onClick) {
            onClick(tagText);
        }
    };
    var anchorWrapper = function(children) {
        var target = openInNewTab ? "_blank" : undefined;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagAnchorWrapper, {
            className: "tag-anchor-wrapper",
            href: href,
            target: target,
            children: children
        });
    };
    var tagImageSize = tagImageHeight || TAG_IMAGE_SIZE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react/* ConditionalWrapper */.M, {
        condition: href,
        wrapper: anchorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTag, {
            className: classnames_default()("tag", {
                "has-on-click-behavior": onClick
            }),
            onClick: onTagClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag-image-wrapper",
                    style: {
                        backgroundColor: colors/* default */.Z[tagBackgroundColor],
                        height: tagImageSize,
                        width: !noImageWidth && tagImageSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        className: "tag-icon",
                        pictureClass: "tag-picture",
                        src: tagIconsrc,
                        pictureComponentHeight: tagImageSize
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag-text",
                    style: {
                        fontSize: tagTextSize
                    },
                    children: tagText
                })
            ]
        })
    });
};
/* harmony default export */ var tag = (Tag);
Tag.defaultProps = default_props;

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component.scss.js


var StyledTagItemsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2800i00"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-wrap:wrap;justify-content:center;.grid-tag-wrapper{margin:16px 32px 16px 0;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var TagItemsGridComponent = function(props) {
    var _gridTags = props.gridTags, gridTags = _gridTags === void 0 ? [] : _gridTags, width = props.width, gridTagsBackgroundColor = props.gridTagsBackgroundColor, gridTagsImageHeight = props.gridTagsImageHeight, noImageWidth = props.noImageWidth, tagTextSize = props.tagTextSize;
    var renderTag = function(gridTag, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid-tag-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag, _object_spread_props(_object_spread({}, gridTag), {
                tagBackgroundColor: gridTagsBackgroundColor,
                tagImageHeight: gridTagsImageHeight,
                noImageWidth: noImageWidth,
                tagTextSize: tagTextSize
            }))
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagItemsGridComponent, {
        className: "tag-items-grid-component",
        style: {
            width: width
        },
        children: gridTags.map(renderTag)
    });
};
TagItemsGridComponent.defaultProps = {
    paddingTop: "16px",
    paddingBottom: "16px",
    gridTags: [
        {
            tagText: "Projects",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Projects_icon_circle.png"
        },
        {
            tagText: "Marketing",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png"
        },
        {
            tagText: "CRM",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/CRM_icon_circle.png"
        },
        {
            tagText: "Software",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/software_icon_circle.png"
        },
        {
            tagText: "Creative & design",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Creative_design_icon_circle.png"
        },
        {
            tagText: "HR",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/HR_icon_circle.png"
        },
        {
            tagText: "Operations",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Operations_icon_circle.png"
        },
        {
            tagText: "IT",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/IT_icon_circle.png"
        },
        {
            tagText: "200+ workflows",
            tagIconsrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/200_workflows_icon_circle.png"
        }
    ]
};
/* harmony default export */ var tag_items_grid_component = (TagItemsGridComponent);


/***/ })

}]);